import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'ChangePassword',
  components: {
    EmailComp: require('../../components/email.vue').default,
    NewPasswordComp: require('../../components/newPassword.vue').default,
  },
  data: function () {
    return {
      email: { email: '', valid: false, },
      password: '',
      passwords: { password: '', password2: '', canContinue: false },
      completed: false,
      message: '',
      isInComm: false,
    }
  },
  computed: {
    changeEnabled: function () {
      return this.email.valid && this.passwords.canContinue && !this.isInComm && !this.completed;
    },
  },
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
    changePassword() {
      this.isInComm = true;
      axios.post('/account/ChangePassword', { Username: this.email.email, CurrentPassword: this.password, NewPassword: this.passwords.password })
        .then(response => {
          this.isInComm = false;
          this.completed = true;
          if (response.data.data.status == 0) {
            this.message = 'Password changed successfully.';
            setTimeout(function () { this.redirectBack(); }.bind(this), 3000);
          }
          else {
            this.message = response.data.data.text;
          }
        })
        .catch(e => { this.message = e.message })
    },
  },
}
